import { ROLE_LABELS, roleName, useRoles } from "@/lib/permissions";

/** Crew picker that offers whole teams (roles) and individual people. */
export function CrewSelect({ value, onChange, crewList = [], testid, className }) {
  const { roles, labels } = useRoles();
  const teamLabel = (r) =>
    (labels[r] || ROLE_LABELS[r] || roleName(r)).split("—")[0].trim();
  return (
    <select
      data-testid={testid}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={
        className ||
        "h-10 w-full rounded border border-zinc-800 bg-zinc-950 px-2 text-sm text-zinc-200"
      }
    >
      <option value="">Unassigned</option>
      <optgroup label="Teams">
        {roles.map((r) => (
          <option key={r} value={`group:${r}`}>
            {teamLabel(r)} (team)
          </option>
        ))}
      </optgroup>
      <optgroup label="People">
        {crewList.map((c) => {
          const n = c.name || c.email;
          return (
            <option key={c.id || n} value={n}>
              {n}
            </option>
          );
        })}
      </optgroup>
    </select>
  );
}
